import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';

import { Note } from 'types';

import TableBody from 'modules/_shared/Table/components/TableBody';

import { useNotesSection } from '../context/NotesSectionContext';
import NotesSectionTableRow from './NotesSectionTableRow';

const NotesSectionTableBody: FC = () => {
  const { t } = useTranslate();

  const { data } = useNotesSection();

  const hasData = data.notes?.length > 0;

  const rows = data.notes!.map((note: Note, index: number) => (
    <NotesSectionTableRow
      key={note._id ?? `note-row-${index}`}
      index={index}
      note={note}
    />
  ));

  return (
    <TableBody
      hasData={hasData}
      content={rows}
      noDataMessage={t('NoAnnotations')}
    />
  );
};

export default NotesSectionTableBody;
